import { render, staticRenderFns } from "./AccountHistory.vue?vue&type=template&id=34f8a83e&scoped=true&"
import script from "./AccountHistory.vue?vue&type=script&lang=js&"
export * from "./AccountHistory.vue?vue&type=script&lang=js&"
import style0 from "./AccountHistory.vue?vue&type=style&index=0&id=34f8a83e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f8a83e",
  null
  
)

export default component.exports